import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

import ResetPasswordPage from './forgotPasswordPage'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RigipsStore } from 'redux/redux'

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

const PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`

export type InputProps = {
  email: string
}

export type Variables = {
  email: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const withForgotPasswordMutation = graphql<InputProps, Response, Variables, ChildProps>(
  PASSWORD_MUTATION,
)

export default withForgotPasswordMutation(connect(mapStateToProps)(withRouter(ResetPasswordPage)))
